import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "react-toastify";

import { deleteNotificationComponent } from "../../services/notification_components";


interface IPayload {
    id: number;
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setApiError: React.Dispatch<React.SetStateAction<string | null>>;
};

const useDeleteNotificationComponent = () => {
    const queryClient = useQueryClient();

    const mutationFn = async (payload: IPayload) => {
        return await deleteNotificationComponent(payload.id);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
            variables.setApiError(null);
        },
        onSuccess: (status: number, variables: IPayload) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["custom_notifications"] });
                toast.success("Notification Component deleted successfully!");
            }
            variables.setIsProcessing(false);
            variables.setApiError(null);
        },
        onError: (error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
            variables.setApiError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        },
        onSettled: (status: number | undefined, error: any, variables: IPayload) => {
            if (status === 200) {
                variables.setIsProcessing(false);
                variables.setApiError(null);
            }
        }
    });
};
export default useDeleteNotificationComponent;